import { ArrowShapeDownToLine, Copy, Xmark } from "@gravity-ui/icons";
import { Button, Flex, Icon, Text, Tooltip } from "@gravity-ui/uikit";
import { ExportJobDto } from "definitions/exporter";
import { POIZON_API_SUPPORT_LINK } from "src/constants/links";

import { LogViewer } from "../../widgets";
import { StatusCard } from "./components";

interface ExportLogsContentProps {
  isModal?: boolean;
  job: ExportJobDto | null;
  metadata: string;
  onClose: () => void;
}

export const ExportLogsContent = ({
  isModal,
  job,
  metadata,
  onClose,
}: ExportLogsContentProps) => {
  return (
    <Flex
      direction="column"
      gap={1}
      style={{ padding: 20, minWidth: isModal ? 600 : "unset" }}
    >
      <Flex justifyContent={"space-between"}>
        <Text variant="subheader-3">Информация о задаче</Text>
        {isModal && (
          <Button view="flat" onClick={onClose}>
            <Icon data={Xmark} />
          </Button>
        )}
      </Flex>
      <br />
      <Flex direction={"column"} gap={6}>
        <Flex alignItems={"center"} justifyContent={"start"} gap={4}>
          <StatusCard type="success" count={job?.statuses?.success?.count} />
          <StatusCard
            type="warning"
            count={job?.statuses?.warnings?.messages?.length}
          />
          <StatusCard
            type="error"
            count={
              (job?.statuses?.errors?.messages?.length ?? 0) +
              (job?.failedReason ? 1 : 0)
            }
          />
        </Flex>
        <LogViewer logs={job?.statuses} failedReason={job?.failedReason} />
        <Flex alignItems={"center"} gap={2}>
          <Button
            size="l"
            view="outlined-info"
            target="_blank"
            href={POIZON_API_SUPPORT_LINK}
            onClick={() => navigator.clipboard.writeText(metadata)}
          >
            Написать в поддержку
          </Button>
          <Tooltip content={"Скопировать метаданные задачи"} openDelay={200}>
            <Button
              size="l"
              view="outlined"
              onClick={() => navigator.clipboard.writeText(metadata)}
            >
              <Icon data={Copy} />
            </Button>
          </Tooltip>

          <Tooltip content={"Скачать логи задачи"} openDelay={200}>
            <Button
              size="l"
              view="outlined"
              href={job?.logFileLink}
              target="_blank"
            >
              <Icon data={ArrowShapeDownToLine} />
            </Button>
          </Tooltip>
        </Flex>
      </Flex>
    </Flex>
  );
};
